import React from "react";
import "../styles/ChairPopup.css";
import { ChairPopupProps } from "../types";
import { useEnvironment } from "../contexts/EnvironmentContext";

const ChairPopup: React.FC<ChairPopupProps> = ({ occupant, isVisible, position }) => {
  const { config } = useEnvironment();
  
  if (!isVisible || !occupant || !config.showPopups) return null;

  return (
    <div
      className="chair-popup"
      style={{
        left: position.x,
        top: position.y,
      }}
    >
      <div className="popup-content">
        <div className="popup-header">
          <div className="popup-avatar">
            {occupant.name.charAt(0).toUpperCase()}
          </div>
          <div className="popup-info">
            <div className="popup-name">{occupant.name}</div>
            <div className="popup-role">{occupant.role}</div>
          </div>
        </div>
        {config.showOccupantDetails && (
          <div className="popup-details">
            <div className="popup-detail">
              <span className="popup-label">Email:</span>
              <span className="popup-value">{occupant.email}</span>
            </div>
            <div className="popup-detail">
              <span className="popup-label">Status:</span>
              <span className={`popup-status ${occupant.status}`}>
                {occupant.status}
              </span>
            </div>
          </div>
        )}
      </div>
      <div className="popup-arrow"></div>
    </div>
  );
};

export default ChairPopup;
